// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface QueueServicesListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface QueueServicesSetServicePropertiesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface QueueServicesGetServicePropertiesOptionalParams extends OperationOptions {}
